import React, {FC, useEffect, useState} from 'react';

import path_up from 'assets/images/closeSelectIcon.svg';
import path_down from 'assets/images/openSelectIcon.svg';
import iconStateDisabled from "assets/icons/commons/source-state-disabled.svg"
import iconStateSuccess from "assets/icons/commons/source-state-active.svg"
import iconStateError from "assets/icons/commons/source-state-error.svg"
import ToggleButton from "../ToggleButton";
import {DataSource} from "../../../constants/DataSource/DataSource";
import {DataSourceStatus} from "../../../constants/DataSource/DataSourceStatus";
import {t} from "i18next";
import FormSelect, {ISelectOption} from "../../commons/Select/FormSelect";
import {v4 as uuidv4} from "uuid";
import classNames from "classnames";
import {FrequencySelector} from "../FrequencySelector";

interface DataSourceProps {
  code: string
  data: DataSource|null
  updateDataSourceHandler: (code: string, payload: DataSource|null) => void
  toggleIsDisclosed: (code: string) => void
  toggleItemStatus: (code: string, isActive: boolean) => void
  isDisclosed: boolean
  isActive: boolean
}

export const P5S: FC<DataSourceProps> = ({
  code,
  data,
  updateDataSourceHandler,
  toggleIsDisclosed,
  toggleItemStatus,
  isDisclosed,
  isActive
}) => {

  const title = 'p5s.ru - Поставщик счастья'

  const onStatusChange = (isActiveStatus: boolean) => {
    isActive = isActiveStatus
    toggleItemStatus(code, isActiveStatus)
  };

  // Param - frequency
  const onUpdateFrequencyChange = (frequency: number) => {
    setUpdateFrequency(frequency)
  };
  const [updateFrequency, setUpdateFrequency] = useState(0);

  // Param - identity field in source
  const availableSkuFieldIds: {[key: string]: string} = {
    "aID": "aID",
    "barcode": "barcode",
  }
  const defaultSkuFieldId = "aID"
  const [skuFieldId, setSkuFieldId] = useState(defaultSkuFieldId);
  const [skuFieldIdSelectorOptions, setSkuFieldIdSelectorOptions] = useState<ISelectOption[]>([]);

  // Param - internal identity field
  const availableMapByOptions: {[key: string]: string} = {
    "sku": "Артикул",
    "barcode": "Штрих-код",
    "id": "ID LK",
  }
  const defaultMapBy = "sku"
  const [mapBy, setMapBy] = useState(defaultMapBy);
  const [mapBySelectorOptions, setMapBySelectorOptions] = useState<ISelectOption[]>([]);

  const [errors, setErrors] = useState({url: '', stockFieldId: ''});

  // @ts-ignore
  const fieldsWithErrors = Object.keys(errors).filter((k: string) => errors[k].length > 0)
  const isFormHasErrors = fieldsWithErrors.length > 0
  const state = isActive ? (isFormHasErrors ? 'fail' : 'success') : 'disabled'
  const dataSourceStateIconAssets = {
    'disabled': iconStateDisabled,
    'success': iconStateSuccess,
    'fail': iconStateError
  }

  useEffect(() => {
    const skuFieldIdSelectOptions: ISelectOption[] = []
    for (const key in availableSkuFieldIds) {
      skuFieldIdSelectOptions.push({text: availableSkuFieldIds[key], value: key})
    }
    setSkuFieldIdSelectorOptions(skuFieldIdSelectOptions)


    const mapBySelectOptions: ISelectOption[] = []
    for (const key in availableMapByOptions) {
      mapBySelectOptions.push({text: availableMapByOptions[key], value: key})
    }
    setMapBySelectorOptions(mapBySelectOptions)
  }, [])

  useEffect(() => {
    if (!data) {
      toggleItemStatus(code, false)
    }

    // @ts-ignore
    setSkuFieldId(data?.configMap.skuFieldId || defaultSkuFieldId)
    // @ts-ignore
    setMapBy(data?.configMap.mapBy || defaultMapBy)

    setUpdateFrequency(data?.updateFrequency || 0)

  }, [data])

  useEffect(() => {
    if (!data && isActive) {
      data = {
        uuid: uuidv4(),
        code: code,
        configMap: {},
        name: title,
        status: isActive ? DataSourceStatus.Current : DataSourceStatus.Archived,
        updateFrequency: 0,
      }
    }

    if (data) {
      data.updateFrequency = updateFrequency
      data.configMap = {
        skuFieldId: skuFieldId,
        mapBy: mapBy,
      }
      updateDataSourceHandler(code, data)
    }

  }, [skuFieldId, mapBy, updateFrequency, isActive])

  const customInputClassName = 'border-[#E2E8F0] mb-1 px-3 py-2 rounded-md text-sm shadow-sm placeholder-slate-400  w-full focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none'

  function updateFrequencyHandler(e: any): void {
    setUpdateFrequency(parseInt(e.target.value))
  }

  return (
    <div
      className="border-[1.75px] p-2 mt-4 cursor-pointer rounded-[5px] select-none shadow-smooth"
    >
      <div className="flex max-h-11 rounded items-center justify-between" onClick={() => toggleIsDisclosed(code)}>
        <div className="flex items-center min-w-36">
          <div className="text-xs flex flex-row text-[#1E293B] font-medium  text-sm">
            <img src={dataSourceStateIconAssets[state]} className="mr-2" />
            {title}
          </div>
        </div>
        <div className="flex items-center">
          <ToggleButton
            label="Подключен"
            labelId="название-опции-тут"
            onChange={onStatusChange}
            isChecked={isActive}
          />
          <div>
            <div>
              <img src={isDisclosed ? path_up : path_down} alt={''} />
            </div>
          </div>
        </div>

      </div>
      {isDisclosed && (
          <div className={'mt-4'}>
            <div className="mt-4">
              Сопоставить по значению
            </div>
            <div className="mt-4 flex flex-row">

              <div className={`w-1/2`}>
                <FormSelect
                    id="p5s_mapBy"
                    name="p5s_mapBy"
                    value={mapBy}
                    label={t<string>("LK", { ns: "messages" })}
                    changeHandler={event => setMapBy(event.target.value)}
                    customClassName={classNames(customInputClassName)}
                    customLabelClassName="text-sm"
                    blurHandler={event => setMapBy(event.target.value)}
                    validationError={false}
                    validationErrorDescription={''}
                    options={mapBySelectorOptions}
                    require={false}
                ></FormSelect>
              </div>
              <div className={`p-4 flex items-end`}>=</div>
              <div className={`w-1/2`}>
                <FormSelect
                    id="p5s_skuFieldId"
                    name="p5s_skuFieldId"
                    value={skuFieldId}
                    label={t<string>("XML/P5S", { ns: "messages" })}
                    changeHandler={event => setSkuFieldId(event.target.value)}
                    customClassName={classNames(customInputClassName)}
                    customLabelClassName="text-sm"
                    blurHandler={event => setSkuFieldId(event.target.value)}
                    validationError={false}
                    validationErrorDescription={''}
                    options={skuFieldIdSelectorOptions}
                    require={false}
                ></FormSelect>
              </div>

            </div>
            <div className="mt-4">

            </div>
            <div className="mt-4 flex justify-between">
              <div className={"w-5/12"}>
                <FrequencySelector data={updateFrequency} onChange={onUpdateFrequencyChange}></FrequencySelector>
              </div>
              {data &&
                  <button
                      className="self-end items-center text-sm text-left font-medium mb-1 border-[1px] px-[15px] h-[42px] rounded mt-2 active:outline-none"
                      onClick={()=> {data = null; updateDataSourceHandler(code, data); console.log("DATA", data)}}
                      type={"button"}
                  >
                    Удалить источник
                  </button>
              }

            </div>

          </div>
      )}
    </div>
  );
};
